export default __webpack_public_path__ + "static/media/TE (4).7bdc6533.jpg";